export function initAccordions() {
  function toggleAccordion(event) {
    const { target } = event;
    const btn = target.closest('button[data-action="accordion"]');
    if (!btn) return;
    btn.classList.toggle('is-open');
  }

  document.addEventListener('click', toggleAccordion);
}
